import script from "./SolutionDetailEN.vue?vue&type=script&setup=true&name=SolutionDetailEN&lang=js"
export * from "./SolutionDetailEN.vue?vue&type=script&setup=true&name=SolutionDetailEN&lang=js"

import "./SolutionDetailEN.vue?vue&type=style&index=0&id=5a043756&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a043756"]])

export default __exports__